import React from "react";

const BlueWave = () => {
  return <section className="wave-blue" />;
};

export default BlueWave;
